import { OVERVIEW_PERIOD } from '../RentalPortalOverview.constants'

export const QA_NAME_OVERVIEW_PERIOD_SELECT = 'rentalPortalOverviewPeriodSelect'

export const QA_NAME_OVERVIEW_PERIOD_ERROR = 'rentalPortalOverviewPeriodError'

export const OVERVIEW_PERIOD_LABEL_KEY = {
  [OVERVIEW_PERIOD.last30]: 'RentalPortal.OverviewPeriodLast30Key',
  [OVERVIEW_PERIOD.thisMonth]: 'RentalPortal.OverviewPeriodThisMonthKey',
  [OVERVIEW_PERIOD.thisWeek]: 'RentalPortal.OverviewPeriodThisWeekKey',
}
